import styled from 'styled-components'

import { helpers } from 'styles'

export const Label = styled.label`
	font-size: ${helpers.font.size.small};
	display: block;
	margin: 12px 0 4px;
`
